import { useState, useEffect } from 'react'
import React from 'react';
import { useParams } from 'react-router-dom';
import '../styles/App.css';
import InputGame from './InputGame.js';
import GrilleGame from './GrilleGame.js';
import Countdown from './Countdown.js';
import Prev from './Prev.js';
import Rules from './Rules.js';
import Nav from './Nav.js';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


function ModeGame() {

  const gameMode = 'game'
  const { id } = useParams();
  const isArchive = !!id;

  // Crée un nouvel objet Date avec la date et l'heure actuelles
  var dateDuJour = new Date();
  // Récupère les composantes de la date
  var annee = dateDuJour.getFullYear();
  var mois = (dateDuJour.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0 en JS, donc on ajoute 1
  var jour = dateDuJour.getDate().toString().padStart(2, '0');
  // Formate la date en "yyyy-mm-dd"
  var dateFormatee = `${annee}-${mois}-${jour}`;


  const [gameFind, setgameFind] = useState(0);


  const storageKey = isArchive ? `rows-game-archive-${id}` : 'rows-game';
  const savedrowsLocal = localStorage.getItem(storageKey)
  let savedrows = null;
  if (savedrowsLocal) {
    savedrows = isArchive
      ? JSON.parse(savedrowsLocal) // en archive, pas de filtre par date : toute la partie appartient à ce puzzle
      : JSON.parse(savedrowsLocal).filter(row => row.dateFormatee === dateFormatee && row.gameMode === gameMode);
  }


  const [gameNow, setGameNow] = useState([]);
  const [nbTest, nbTestUpdate] = useState(savedrows ? savedrows.length : 0)
  const [nbTestMax, nbTestMaxUpdate] = useState(nbTest === 10 ? 1 : 0)

  
  // Initialiser gameNow avec l'item du jour
  useEffect(() => {
    const fetchgameNow = async () => {
      try {
        const url = isArchive
          ? `${URL_BACKEND}/api/history/game/${id}`
          : `${URL_BACKEND}/api/games-now`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Data game fetched successfully:', data);
        setGameNow(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchgameNow();
  }, [id, isArchive]);

  
	const [rows, rowsUpdate] = useState(savedrows ? savedrows : [])
  // Stockage des inputs dans le localstorage + mise à jour
	useEffect(( ) => {
    if (gameNow.length === 0) {
      // Wait until gameNow is fetched
      return;
    }
		localStorage.setItem(storageKey, JSON.stringify(rows))

    // Mise à jour du nombre de coup
    nbTestUpdate(rows.length)
    console.log('lenght', rows.length)
    // Mise à jour si le nombre de coup est de 10
    rows.length === 10 ? nbTestMaxUpdate(1) : nbTestMaxUpdate(0)
    
    // Mise à jour si le nombre de coup est de 10
    if (rows.length > 0 && rows[0].id_jeu === gameNow.id_jeu) { setgameFind(1) } else  { setgameFind(0) }

    // On met à jour localStorage pour mettre la valeur solved à 1 si l'item a été trouvé
    if (rows.length > 0 && (rows[0].id_jeu === gameNow.id_jeu || rows.length === 10)) {
      const solvedKey = isArchive ? 'solved-archive' : 'solved-today';
      const mode = 'game';
      const gameId = isArchive ? Number(id) : 'today';
      const solvedValue = rows.length === 10 ? 0 : 1;

      // on relit tout l'objet racine (tous les modes), pas juste 'item'
      const root = JSON.parse(localStorage.getItem(solvedKey) || '{}');

      // on récupère le sous-objet du mode courant, sécurisé si absent/corrompu
      const modeData =
        root[mode] && typeof root[mode] === 'object' ? root[mode] : {};

      // on fusionne : on garde les autres ids, on met à jour/ajoute itemId
      root[mode] = {
        ...modeData,
        [gameId]: { state: 1, solved: solvedValue },
      };

      localStorage.setItem(solvedKey, JSON.stringify(root));

      console.log(`localStorage['${solvedKey}'] after update:`, root);
    }

	}, [rows, gameNow])

    return (
      <div >
        <Nav />
        <InputGame       
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            gameNow={gameNow}
            setGameNow={setGameNow}
            gameFind={gameFind}
            nbTestMax={nbTestMax}
            nbTest={nbTest}
            dateFormatee={isArchive ? gameNow.date_historique : dateFormatee}
        />
        {nbTestMax === 1 || gameFind === 1 ?
            (!isArchive && <Countdown
              gameMode={gameMode}
            />)
            : null
          }
        <GrilleGame
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            gameNow={gameNow}
            setGameNow={setGameNow}
            dateFormatee={isArchive ? gameNow.date_historique : dateFormatee}
        />
        <Prev 
          gameMode={gameMode} 
          isArchive={isArchive}
          currentId={id}
        />
        <Rules 
          gameMode={gameMode} 
        />   
    </div>
	)
}

export default ModeGame
